import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";

export default function Refunds() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <nav className="border-b border-border/50 backdrop-blur-sm sticky top-0 z-40 bg-background/80">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between">
          <Link to="/" aria-label="Home"><Logo variant="full" className="h-12 sm:h-14 object-contain" /></Link>
          <Link to="/pricing"><Button variant="ghost" size="sm">Pricing</Button></Link>
        </div>
      </nav>
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 prose prose-invert prose-headings:font-display prose-headings:font-bold prose-h1:text-4xl prose-h2:text-2xl prose-h2:mt-10 prose-p:text-muted-foreground prose-li:text-muted-foreground prose-a:text-primary">
        <h1>Refund Policy</h1>
        <p className="text-sm">Last updated: April 28, 2026</p>

        <h2>30-day money-back guarantee</h2>
        <p>
          We offer a <strong>30-day money-back guarantee</strong>. If Pull Over Sales isn't right
          for you, you can request a full refund within 30 days of your first paid invoice. No
          questions asked.
        </p>

        <h2>How to request a refund</h2>
        <p>
          Refunds are processed by our payment provider, <strong>Paddle</strong>, which is the
          Merchant of Record for all Pull Over Sales orders. To request a refund:
        </p>
        <ul>
          <li>Visit <a href="https://paddle.net" target="_blank" rel="noreferrer">paddle.net</a> with the email used for purchase, or</li>
          <li>Contact our support team and we'll arrange it with Paddle on your behalf.</li>
        </ul>

        <h2>Cancellations</h2>
        <p>
          You may cancel your subscription at any time from the customer portal in Settings, or via{" "}
          <a href="https://paddle.net" target="_blank" rel="noreferrer">paddle.net</a>. When you
          cancel, you keep access to Pull Over Sales until the end of the period you've already paid
          for; your subscription will not renew after that.
        </p>

        <h2>Free trial</h2>
        <p>
          The 14-day free trial is non-charging. You will not be billed until the trial ends. Cancel
          before the trial ends to avoid any charge.
        </p>

        <h2>Questions</h2>
        <p>If you're unsure whether your situation qualifies, contact support — we're reasonable.</p>
      </article>
    </div>
  );
}